/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestReset } from './QuestReset';
import {
    QuestResetFromJSON,
    QuestResetFromJSONTyped,
    QuestResetToJSON,
    QuestResetToJSONTyped,
} from './QuestReset';
import type { CreateMilestoneRequest } from './CreateMilestoneRequest';
import {
    CreateMilestoneRequestFromJSON,
    CreateMilestoneRequestFromJSONTyped,
    CreateMilestoneRequestToJSON,
    CreateMilestoneRequestToJSONTyped,
} from './CreateMilestoneRequest';
import type { OWRewardMaxType } from './OWRewardMaxType';
import {
    OWRewardMaxTypeFromJSON,
    OWRewardMaxTypeFromJSONTyped,
    OWRewardMaxTypeToJSON,
    OWRewardMaxTypeToJSONTyped,
} from './OWRewardMaxType';
import type { OWLogCategory } from './OWLogCategory';
import {
    OWLogCategoryFromJSON,
    OWLogCategoryFromJSONTyped,
    OWLogCategoryToJSON,
    OWLogCategoryToJSONTyped,
} from './OWLogCategory';
import type { OWRewardMode } from './OWRewardMode';
import {
    OWRewardModeFromJSON,
    OWRewardModeFromJSONTyped,
    OWRewardModeToJSON,
    OWRewardModeToJSONTyped,
} from './OWRewardMode';

/**
 * 
 * @export
 * @interface OWQuestBody
 */
export interface OWQuestBody {
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    game?: string;
    /**
     * The title of the reward.
     * @type {string}
     * @memberof OWQuestBody
     */
    name: string;
    /**
     * The description of the reward.
     * @type {string}
     * @memberof OWQuestBody
     */
    description?: string;
    /**
     * If the quest is active (shows on FE and tracks in the BE) or not.
     * @type {boolean}
     * @memberof OWQuestBody
     */
    isActive: boolean;
    /**
     * If the quest complete notification should be shown.
     * @type {boolean}
     * @memberof OWQuestBody
     */
    showQuestCompleteNotification?: boolean;
    /**
     * The message to show in the quest complete notification.
     * @type {string}
     * @memberof OWQuestBody
     */
    questCompleteNotificationMessage?: string;
    /**
     * The maximum amount of reward that can be claimed.
     * @type {number}
     * @memberof OWQuestBody
     */
    rewardMax?: number;
    /**
     * 
     * @type {OWRewardMaxType}
     * @memberof OWQuestBody
     */
    rewardMaxType?: OWRewardMaxType;
    /**
     * 
     * @type {OWLogCategory}
     * @memberof OWQuestBody
     */
    rewardCategory: OWLogCategory;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    eventType: string;
    /**
     * The target amount of progress to reach to claim the reward.
     * @type {number}
     * @memberof OWQuestBody
     */
    target: number;
    /**
     * 
     * @type {QuestReset}
     * @memberof OWQuestBody
     */
    questReset?: QuestReset;
    /**
     * If the quest is available for all supported games that are not in our database (OWGames).
     * @type {boolean}
     * @memberof OWQuestBody
     */
    onAllSupportedGames?: boolean;
    /**
     * 
     * @type {OWRewardMode}
     * @memberof OWQuestBody
     */
    mode?: OWRewardMode;
    /**
     * Ref to the challenge of this quest (only for challenge quests).
     * @type {string}
     * @memberof OWQuestBody
     */
    challenge?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OWQuestBody
     */
    isSponsored?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    sponsorName?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    logo?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    color?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    externalUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof OWQuestBody
     */
    rewardImage?: string;
    /**
     * 
     * @type {number}
     * @memberof OWQuestBody
     */
    startAt?: number;
    /**
     * 
     * @type {number}
     * @memberof OWQuestBody
     */
    endAt?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof OWQuestBody
     */
    rewardConfigIds?: Array<string>;
    /**
     * 
     * @type {Array<CreateMilestoneRequest>}
     * @memberof OWQuestBody
     */
    milestones?: Array<CreateMilestoneRequest>;
}



/**
 * Check if a given object implements the OWQuestBody interface.
 */
export function instanceOfOWQuestBody(value: object): value is OWQuestBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('rewardCategory' in value) || value['rewardCategory'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    if (!('target' in value) || value['target'] === undefined) return false;
    return true;
}

export function OWQuestBodyFromJSON(json: any): OWQuestBody {
    return OWQuestBodyFromJSONTyped(json, false);
}

export function OWQuestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWQuestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'game': json['game'] == null ? undefined : json['game'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'],
        'showQuestCompleteNotification': json['showQuestCompleteNotification'] == null ? undefined : json['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': json['questCompleteNotificationMessage'] == null ? undefined : json['questCompleteNotificationMessage'],
        'rewardMax': json['rewardMax'] == null ? undefined : json['rewardMax'],
        'rewardMaxType': json['rewardMaxType'] == null ? undefined : OWRewardMaxTypeFromJSON(json['rewardMaxType']),
        'rewardCategory': OWLogCategoryFromJSON(json['rewardCategory']),
        'eventType': json['eventType'],
        'target': json['target'],
        'questReset': json['questReset'] == null ? undefined : QuestResetFromJSON(json['questReset']),
        'onAllSupportedGames': json['onAllSupportedGames'] == null ? undefined : json['onAllSupportedGames'],
        'mode': json['mode'] == null ? undefined : OWRewardModeFromJSON(json['mode']),
        'challenge': json['challenge'] == null ? undefined : json['challenge'],
        'isSponsored': json['isSponsored'] == null ? undefined : json['isSponsored'],
        'sponsorName': json['sponsorName'] == null ? undefined : json['sponsorName'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'color': json['color'] == null ? undefined : json['color'],
        'externalUrl': json['externalUrl'] == null ? undefined : json['externalUrl'],
        'rewardImage': json['rewardImage'] == null ? undefined : json['rewardImage'],
        'startAt': json['startAt'] == null ? undefined : json['startAt'],
        'endAt': json['endAt'] == null ? undefined : json['endAt'],
        'rewardConfigIds': json['rewardConfigIds'] == null ? undefined : json['rewardConfigIds'],
        'milestones': json['milestones'] == null ? undefined : ((json['milestones'] as Array<any>).map(CreateMilestoneRequestFromJSON)),
    };
}

export function OWQuestBodyToJSON(json: any): OWQuestBody {
    return OWQuestBodyToJSONTyped(json, false);
}

export function OWQuestBodyToJSONTyped(value?: OWQuestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'game': value['game'],
        'name': value['name'],
        'description': value['description'],
        'isActive': value['isActive'],
        'showQuestCompleteNotification': value['showQuestCompleteNotification'],
        'questCompleteNotificationMessage': value['questCompleteNotificationMessage'],
        'rewardMax': value['rewardMax'],
        'rewardMaxType': OWRewardMaxTypeToJSON(value['rewardMaxType']),
        'rewardCategory': OWLogCategoryToJSON(value['rewardCategory']),
        'eventType': value['eventType'],
        'target': value['target'],
        'questReset': QuestResetToJSON(value['questReset']),
        'onAllSupportedGames': value['onAllSupportedGames'],
        'mode': OWRewardModeToJSON(value['mode']),
        'challenge': value['challenge'],
        'isSponsored': value['isSponsored'],
        'sponsorName': value['sponsorName'],
        'logo': value['logo'],
        'color': value['color'],
        'externalUrl': value['externalUrl'],
        'rewardImage': value['rewardImage'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'rewardConfigIds': value['rewardConfigIds'],
        'milestones': value['milestones'] == null ? undefined : ((value['milestones'] as Array<any>).map(CreateMilestoneRequestToJSON)),
    };
}

